import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Intro from './components/Intro';
import XCursor from './components/XCursor';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Gap from './components/Gap';
import Founders from './components/Founders';
import Synthesis from './components/Synthesis';
import Work from './components/Work';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Testimonials from './components/Testimonials';
import Downloads from './components/Downloads';
import TickStrip from './components/TickStrip';
import CookieConsent from './components/CookieConsent';
import { Toaster } from './components/ui/sonner';

// Secondary routes - lazy-loaded so they stay out of the initial bundle
const Privacy = lazy(() => import('./components/Privacy'));
const Terms = lazy(() => import('./components/Terms'));

const RouteFallback = () => (
  <div className="min-h-screen" style={{ backgroundColor: 'var(--bg, #0A0D17)' }} />
);

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    let tries = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else if (tries++ < 25) setTimeout(tryScroll, 100);
    };
    const t = setTimeout(tryScroll, 350);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <>
      <Intro />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Gap />
        <Founders />
        <TickStrip label="Synthesising Experiences" />
        <Synthesis />
        <TickStrip label="Story · Space · Systems · Engineered" />
        <Work />
        <Testimonials />
        <FAQ />
        <Downloads />
        <Contact />
      </main>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <div className="blueprint-bg" />
        <XCursor />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Legacy /work/* case-study URLs removed - redirect any old indexed link to home */}
          <Route path="/work/*" element={<Navigate to="/" replace />} />
          <Route path="/privacy" element={<Suspense fallback={<RouteFallback />}><Privacy /></Suspense>} />
          <Route path="/terms" element={<Suspense fallback={<RouteFallback />}><Terms /></Suspense>} />
        </Routes>
        <CookieConsent />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
